module.exports = __webpack_public_path__ + "img/Slideshows-espace-client-guide-rs2.1b477673.png";